export default __webpack_public_path__ + "static/media/Batang.0e4ab0e9.ttf";